<footer id="footer">
  <div class="main-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-xs-12">
          <div class="footer-title">VỀ CHÚNG TÔI</div>
          <div class="about">
            <div class="item">
              <div class="title">Tên công ty</div>
              <div class="content">Công ty Cổ phần Viễn thông FPT</div>
            </div>
            <div class="item">
              <div class="title">Người đại diện</div>
              <div class="content">Ông Hoàng Việt Anh</div>
            </div>
            <div class="item">
              <div class="title">Địa chỉ</div>
              <div class="content">
                Tầng 9, Block A, tòa nhà FPT Cầu Giấy, số 10 Phạm Văn Bạch, quận
                Cầu Giấy, TP. Hà Nội
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="footer-title">LIÊN HỆ</div>
          <div class="contact">
            <div class="item">
              <div class="title">Điện thoại hỗ trợ</div>
              <div class="content">024 7300 2222</div>
            </div>
            <div class="item">
              <div class="title">Email</div>
              <div class="content">hifpt@fpt.com</div>
            </div>
            <div class="item">
              <div class="title">Kết nối với chúng tôi</div>
              <ul class="social">
                <li>
                  <a
                    href="https://www.facebook.com/hifpt.official/"
                    target="_blank"
                    class="button-facebook"
                  >
                    <img
                      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/about-wifi-6/icon-fb.png"
                      alt=""
                      width="auto"
                      height="auto"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@hifptfpttelecom2535"
                    target="_blank"
                    class="button-youtube"
                  >
                    <img
                      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/about-wifi-6/icon-youtube.png"
                      alt=""
                      width="auto"
                      height="auto"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@hifptvn?_t=8iKoqnRtISP&_r=1"
                    target="_blank"
                    class="button-tiktok"
                  >
                    <img
                      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/about-wifi-6/icon-tiktok.png"
                      alt=""
                      width="auto"
                      height="auto"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="footer-title">CẬP NHẬT THÔNG TIN MỚI NHẤT</div>
          <div class="fanpage">
            <iframe
              title="facebook"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fhifpt.official%2F&tabs=cover&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="340"
              height="205"
              style="border: none; overflow: hidden"
              allowfullscreen="true"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="copy-right">
    <div class="container">
      <div>
        Giấy chứng nhận ĐKDN số 0101778163 do Sở Kế hoạch và Đầu tư Thành phố Hà Nội cấp lần đầu ngày 28/07/2005
      </div>
      <div>
        Giấy phép cung cấp dịch vụ viễn thông số 255/GP-CVT do Cục Viễn Thông cấp ngày 07/11/2022
      </div>
    </div>
  </div>
</footer>
